// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ratearticle_buttons__sQzFN","reason":"ratearticle_reason__cpY9v","information":"ratearticle_information__3zmQ2"};